import React from "react";
import styled from "styled-components";

const InfoFooterHeader = ({ children }) => (
  <StyledComponent>{children}</StyledComponent>
);

export default InfoFooterHeader;

const StyledComponent = styled.div`
  font-weight: bolder;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  color: white;
`;
